export default "__VITE_ASSET__Amefudgb__"